
webpack.register(
    'blocks/navigation/header/header',
    function() {
        return import('blocks/navigation/header/header');
    },
    true
);

webpack.register(
    'components/simulation-config/simulation-config',
    function() {
        return import('components/simulation-config/simulation-config');
    },
    true
);
webpack.register(
    'components/geo-targeted-interstitial/geo-targeted-interstitial',
    function() {
        return import('components/geo-targeted-interstitial/geo-targeted-interstitial');
    },
    true
);
webpack.register(
    'components/victory-club/subnavigation/vc-subnavigation',
    function() {
        return import('components/victory-club/subnavigation/vc-subnavigation');
    },
    true
);